











































import { Component, Inject, Prop } from "vue-property-decorator";
import Context from "@/mixins/context";

import {
  ITaxTagsProvider,
  ITaxTagsProviderMethods
} from "@/models/providers/tax";
import { ITaxTag } from "@/models/tax";

@Component({
  components: {
    "tax-tag-grid-item": () =>
      import("@/components/app/global/tax/tags/taxTagsGridItem.vue")
  }
})
export default class TaxTagsGridView extends Context {
  // Inject
  @Inject({ from: "taxTagsProvider" })
  public taxTagsProvider!: () => ITaxTagsProvider;

  @Inject({ from: "taxTagsProviderMethods" })
  public $taxTagsMethods!: ITaxTagsProviderMethods;

  // Props
  @Prop({ default: false })
  public readonly isCheckable!: boolean;

  @Prop({ default: () => [] })
  public checkedTaxTagsIds!: ITaxTag["id"][];

  public get $taxTagsData() {
    return this.taxTagsProvider();
  }

  // Computed

  public get skeletonSize() {
    return (
      this.$taxTagsData.table.total ||
      (this.$store.getters["ui/isMobile"] ? 2 : 6)
    );
  }
}
